import {openPatientInformationDialog} from '@/modules/patients/components/patient-details/about/util'
import {isPendingHl7Import, patientContact} from '@/modules/patients/functions'
import {Patient} from '@cypro/engine/schema'
import {Box, Button} from '@chakra-ui/react'
import {DataList} from '@cypro/ui/components/ui/data-list'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {Tolgee} from '@cypro/ui/integrations/tolgee'
import {useCan} from '@/shared/hooks/use-permissions'
import {useTranslate} from '@tolgee/react'
import {useMemo} from 'react'
import {isDefined} from '@cypro/ui/utils'

export function PatientInformation({patient}: {patient: Patient}) {
  const {t} = useTranslate('common')
  const canEditPatient = useCan('patients.edit')
  const aboutItems = useMemo(() => {
    const homeContact = patientContact(patient, 'home')
    return [
      {label: t('cypro_id'), value: patient?.identifiers?.[0]?.value},
      {label: t('sex'), value: patient.sex ? t(patient.sex) : '-'},
      {label: t('gender'), value: patient.gender ? t(patient.gender) : '-'},
      {label: t('title'), value: patient.title ? t(patient.title) : '-'},
      {label: t('name'), value: patient.givenName || '-'},
      {label: t('surname'), value: patient.familyName || '-'},
      {
        label: t('birth_date'),
        value: isDefined(patient.birthDate) ? new Date(patient.birthDate).toLocaleDateString(Tolgee.locale) : '-',
      },
      {label: t('email'), value: homeContact?.email || '-'},
      {label: t('phone'), value: homeContact?.phone || '-'},
      {label: t('business_phone'), value: homeContact?.businessPhone || '-'},
      {label: t('nationality'), value: '-'},
      {label: t('hospital_patient_id'), value: patient.hospitalPatientId || '-'},
      {label: t('national_id_number'), value: patient.nationalId || '-'},
      {label: t('country'), value: homeContact?.address?.country || '-'},
      {
        label: t('address'),
        value: [
          homeContact?.address?.addressLine || '-',
          homeContact?.address?.city || '-',
          homeContact?.address?.region || '-',
          homeContact?.address?.postalCode || '-',
        ].join(', '),
      },
      {label: t('notes'), value: patient.notes || '-'},
      {
        label: t('allow_barcode_id_print'),
        value: patient?.barcodePrintFlag ? t('yes') : t('no'),
      },
    ]
  }, [t, patient])
  return (
    <Box rounded="md" borderWidth="1px" padding="4">
      <DataSection
        label={
          <Box display="flex" flexDirection="row" justifyContent="space-between">
            {t('patient_information')}
            <Button
              variant="ghost"
              colorPalette="cyan"
              disabled={!canEditPatient || isPendingHl7Import(patient)}
              onClick={() => patient && openPatientInformationDialog(patient)}
            >
              {t('edit')}
            </Button>
          </Box>
        }
      >
        <DataList items={aboutItems} />
      </DataSection>
    </Box>
  )
}
